import { fetchPrefectureAndMunicipalityByZipCodeApi } from "@/api/services/global/constant";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { convertZipCodeToNumber } from "@/utils/input";
import { convertFullWidthToHalfWidth } from "@/utils/pieces";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const useGetPrefectureAndMunicipalityByZipCode = (zipCode: string) => {
  const value = convertZipCodeToNumber(convertFullWidthToHalfWidth(zipCode));

  return useQuery({
    queryKey: [QUERY_KEYS.GLOBAL.FETCH_PREFECTURE_AND_MUNICIPALITY_BY_ZIP_CODE, value],
    queryFn: () => (value?.length === 7 ? fetchPrefectureAndMunicipalityByZipCodeApi(value) : undefined),
    enabled: Boolean(value),
  });
};

export const useFetchPrefectureAndMunicipalityByZipCode = () => {
  const queryClient = useQueryClient();

  const fetchByZipCode = async (zipCode: string) => {
    if (!zipCode) return undefined;

    return await queryClient.fetchQuery({
      queryKey: [QUERY_KEYS.GLOBAL.FETCH_PREFECTURE_AND_MUNICIPALITY_BY_ZIP_CODE, zipCode],
      queryFn: () => fetchPrefectureAndMunicipalityByZipCodeApi(zipCode),
    });
  };

  return { fetchByZipCode };
};
